import {BrowserModule} from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import {HttpClientModule} from '@angular/common/http';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';

import {ScreenOrientation} from '@ionic-native/screen-orientation';

import {Dialogs} from '@ionic-native/dialogs';
import {Camera} from '@ionic-native/camera';
import {MediaCapture} from '@ionic-native/media-capture';
import {Media} from '@ionic-native/media';
import {File} from '@ionic-native/file';
import {Transfer} from '@ionic-native/transfer';
import {Network} from '@ionic-native/network';
import {VideoEditor} from '@ionic-native/video-editor';
import {SpinnerDialog} from '@ionic-native/spinner-dialog';
import {CameraPreview} from '@ionic-native/camera-preview';

import {IonicSelectableModule} from 'ionic-selectable';

import {IonicStorageModule} from '@ionic/storage';
import {WebCamModule} from 'ack-angular-webcam';

import {MyApp} from './app.component';
import {LoginPageModule} from '../pages/login/login.module';
import {TermsPageModule} from '../pages/terms/terms.module';
import {MainPageModule} from '../pages/main/main.module';
import {ProofListPageModule} from '../pages/proof-list/proof-list.module';
import {HelpPageModule} from '../pages/help/help.module';
import {ProofTermsPageModule} from '../pages/proof-terms/proof-terms.module';
import {
  IdentificationCheckOnWebPageModule
} from '../pages/identification-check-on-web/identification-check-on-web.module';
import {
  IdentificationCheckOnAppPageModule
} from '../pages/identification-check-on-app/identification-check-on-app.module';
import {ProofTermsBeforeBeginPageModule} from '../pages/proof-terms-before-begin/proof-terms-before-begin.module';
import {ProofBeforeBeginPageModule} from '../pages/proof-before-begin/proof-before-begin.module';
import {ProofOnAppPageModule} from '../pages/proof-on-app/proof-on-app.module';
import {ProofOnWebPageModule} from '../pages/proof-on-web/proof-on-web.module';
import {ProofAfterEndPageModule} from '../pages/proof-after-end/proof-after-end.module';
// import { ProofResponseFeedbackPageModule } from '../pages/proof-response-feedback/proof-response-feedback.module';
// import { ProofResponseFeedbackListPageModule } from '../pages/proof-response-feedback-list/proof-response-feedback-list.module';
// import { ProofResponseFeedbackDetailPageModule } from '../pages/proof-response-feedback-detail/proof-response-feedback-detail.module';
import {NewRegistrationStep1PageModule} from '../pages/new-registration-step1/new-registration-step1.module';
import {NewRegistrationTermsPageModule} from '../pages/new-registration-terms/new-registration-terms.module';
import {NewRegistrationStep2PageModule} from '../pages/new-registration-step2/new-registration-step2.module';
import {NewRegistrationStep3PageModule} from '../pages/new-registration-step3/new-registration-step3.module';
import {NewRegistrationExistsPageModule} from '../pages/new-registration-exists/new-registration-exists.module';
import {UpdateRegistrationPageModule} from '../pages/update-registration/update-registration.module';
import {
  UpdateRegistrationContactPageModule
} from '../pages/update-registration-contact/update-registration-contact.module';
import {
  UpdateRegistrationAddress1PageModule
} from '../pages/update-registration-address1/update-registration-address1.module';
import {
  UpdateRegistrationAddress2PageModule
} from '../pages/update-registration-address2/update-registration-address2.module';
import {
  UpdateRegistrationPersonalPageModule
} from '../pages/update-registration-personal/update-registration-personal.module';
import {
  UpdateRegistrationParentPageModule
} from '../pages/update-registration-parent/update-registration-parent.module';
import {
  UpdateRegistrationDocumentPageModule
} from '../pages/update-registration-document/update-registration-document.module';
import {
  UpdateCertificationDocumentPageModule
} from '../pages/update-certification-document/update-certification-document.module';
import {UpdateTitleDocumentPageModule} from '../pages/update-title-document/update-title-document.module';
//import { UpdateContinuousImprovementDocumentModule } from '../pages/update-continuous-improvement-document/update-continuous-improvement-document.module';
import {
  UpdateRegistrationAffiliatedPageModule
} from '../pages/update-registration-affiliated/update-registration-affiliated.module';
import {
  UpdateRegistrationPasswordPageModule
} from '../pages/update-registration-password/update-registration-password.module';
import {SubscriptionListPageModule} from '../pages/subscription-list/subscription-list.module';
import {NewSubscriptionStep1PageModule} from '../pages/new-subscription-step1/new-subscription-step1.module';
import {NewSubscriptionStep2PageModule} from '../pages/new-subscription-step2/new-subscription-step2.module';
import {NewSubscriptionStep3PageModule} from '../pages/new-subscription-step3/new-subscription-step3.module';
import {NewSubscriptionStep4PageModule} from '../pages/new-subscription-step4/new-subscription-step4.module';
import {CertificatedPageModule} from '../pages/certificated/certificated.module';
// import { ProofListFinishedModule } from '../pages/proof-list-finished/proof-list-finished.module';
// import { QuizzAboutPageModule } from '../pages/quizz-about/quizz-about.module';
// import { QuizzListPageModule } from '../pages/quizz-list/quizz-list.module';
// import { QuizzDetailPageModule } from '../pages/quizz-detail/quizz-detail.module';
// import { QuizzQuestionPageModule } from '../pages/quizz-question/quizz-question.module';
import {IdCardPageModule} from '../pages/idcard/idcard.module';
import {PeripheralCheckPageModule} from '../pages/peripheral-check/peripheral-check.module';

import {ProofServerProvider} from '../providers/proof-server/proof-server';
import {MediaProvider} from '../providers/media/media';
import {AlertProvider} from '../providers/alert/alert';
import {ProofProvider} from '../providers/proof/proof';
import {ProofCameraProvider} from '../providers/proof-camera/proof-camera';
import {ProofAudioProvider} from '../providers/proof-audio/proof-audio';
import {NetworkMonitorProvider} from '../providers/network-monitor/network-monitor';
import {ValidatorProvider} from '../providers/validator/validator';
import {AuthProvider} from '../providers/auth/auth';
import {FileProvider} from '../providers/file/file';
import {DateTimeProvider} from '../providers/datetime/datetime';
import {SystemProvider} from '../providers/system/system';
import {AddressServerProvider} from '../providers/address-server/address-server';
import {NewRegistrationProvider} from '../providers/new-registration/new-registration';
import {EventEmitterProvider} from '../providers/event-emitter/event-emitter';
import {NewSubscriptionProvider} from '../providers/new-subscription/new-subscription';
import {SubscriptionServerProvider} from '../providers/subscription-server/subscription-server';
import {RegistrationProvider} from '../providers/registration/registration';
import {CertificatedProvider} from '../providers/certificated/certificated';
import {QuizzProvider} from '../providers/quizz/quizz';
import {PaymentHttpProvider} from '../providers/payment-http/payment-http';
import {VoucherServerProvider} from '../providers/voucher-server/voucher-server';
import {QuizzServerProvider} from '../providers/quizz-server/quizz-server';
import {IdCardServerProvider} from '../providers/idcard-server/idcard-server';
import {
  QuizzQuestionSelfieOnWebPageModule
} from '../pages/quizz-question-selfie-on-web/quizz-question-selfie-on-web.module';
import {TitleProvider} from '../providers/title/title';
import {ActivityMonitorProvider} from '../providers/activity-monitor/activity-monitor';

import {FileUploadModule} from 'ng2-file-upload';
import {UploadingProvider} from '../providers/uploading/uploading';
import {Geolocation} from '@ionic-native/geolocation';
import {NativeGeocoder} from '@ionic-native/native-geocoder';


import {NetworkInterface} from '@ionic-native/network-interface';
import {QRCodeModule} from 'angularx-qrcode';

import {PopovercomponentPageModule} from '../pages/popovercomponent/popovercomponent.module';

import {WindowProtectorProvider} from '../providers/window-protector/window-protector';
import {ScreenDetailsProvider} from '../providers/screen-details/screen-details';
import {FullscreenProvider} from '../providers/fullscreen/fullscreen';

@NgModule({
  declarations: [
    MyApp,
  ],

  imports: [
    FileUploadModule,
    BrowserModule,
    HttpModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp, {
      mode: 'md',
      iconMode: 'ios',
      platforms: {
        ios: {
          tabsPlacement: 'top',
          backButtonText: 'Voltar'
        }
      }
    }),
    IonicStorageModule.forRoot(),
    WebCamModule,
    LoginPageModule,
    TermsPageModule,
    MainPageModule,
    ProofListPageModule,
    HelpPageModule,
    ProofTermsPageModule,
    IdentificationCheckOnWebPageModule,
    IdentificationCheckOnAppPageModule,
    ProofTermsBeforeBeginPageModule,
    ProofBeforeBeginPageModule,
    ProofOnAppPageModule,
    ProofOnWebPageModule,
    ProofAfterEndPageModule,
    // ProofResponseFeedbackPageModule,
    // ProofResponseFeedbackListPageModule,
    // ProofResponseFeedbackDetailPageModule,
    NewRegistrationStep1PageModule,
    NewRegistrationTermsPageModule,
    NewRegistrationStep2PageModule,
    IonicSelectableModule,
    NewRegistrationStep3PageModule,
    NewRegistrationExistsPageModule,
    UpdateRegistrationPageModule,
    UpdateRegistrationContactPageModule,
    UpdateRegistrationAddress1PageModule,
    UpdateRegistrationAddress2PageModule,
    UpdateRegistrationPersonalPageModule,
    UpdateRegistrationParentPageModule,
    UpdateRegistrationDocumentPageModule,
    UpdateRegistrationAffiliatedPageModule,
    UpdateRegistrationPasswordPageModule,
    SubscriptionListPageModule,
    NewSubscriptionStep1PageModule,
    NewSubscriptionStep2PageModule,
    NewSubscriptionStep3PageModule,
    NewSubscriptionStep4PageModule,
    CertificatedPageModule,
    //ProofListFinishedModule,
    UpdateCertificationDocumentPageModule,
    UpdateTitleDocumentPageModule,
    //UpdateContinuousImprovementDocumentModule,
    // QuizzAboutPageModule,
    // QuizzListPageModule,
    // QuizzDetailPageModule,
    // QuizzQuestionPageModule,
    QRCodeModule,
    IdCardPageModule,
    QuizzQuestionSelfieOnWebPageModule,
    PopovercomponentPageModule,
    PeripheralCheckPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
  ],
  providers: [
    StatusBar,
    ScreenOrientation,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Dialogs,
    Camera,
    MediaCapture,
    Media,
    ProofServerProvider,
    MediaProvider,
    File,
    Transfer,
    AlertProvider,
    ProofProvider,
    ProofCameraProvider,
    ProofAudioProvider,
    Network,
    NetworkMonitorProvider,
    ValidatorProvider,
    AuthProvider,
    FileProvider,
    VideoEditor,
    SpinnerDialog,
    DateTimeProvider,
    CameraPreview,
    SystemProvider,
    AddressServerProvider,
    NewRegistrationProvider,
    EventEmitterProvider,
    NewSubscriptionProvider,
    SubscriptionServerProvider,
    RegistrationProvider,
    CertificatedProvider,
    PaymentHttpProvider,
    UploadingProvider,
    VoucherServerProvider,
    Geolocation,
    NativeGeocoder,
    NetworkInterface,
    QuizzProvider,
    QuizzServerProvider,
    IdCardServerProvider,
    TitleProvider,
    WindowProtectorProvider,
    ScreenDetailsProvider,
    FullscreenProvider,
    ActivityMonitorProvider,
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts